import { Injectable } from '@angular/core';
declare var PDFJS: any;

/*
service resposible for coverting the pdf and return the text value to the frount
*/
@Injectable()
export class DocumentParserProvider {
  base64textString: any;
  constructor() {
    console.log('Hello DocumentParserProvider Provider');
  }




  handelFileSelection(evt) {
    let promises = []
    let data = [];
    return new Promise((resolve, reject) => {
      var files = evt.target.files;
      var file = files[0];
      if (files && file) {
        this.readFile(file).then((binaryString: string) => {
          this.base64textString = btoa(binaryString);
          let pdfBase64 = btoa(binaryString);
          var pdfData = this.base64ToUint8Array(pdfBase64);
          PDFJS.disableWorker = true;
          var pdf = PDFJS.getDocument(pdfData);
          pdf.then(pdfData => {
            let index = 1;
            do {
              promises.push(pdfData.getPage(index).then(pageData => {
                pageData.getTextContent().then((textContent) => {
                  console.log(textContent);
                  data = data.concat(this.formatTxtArray(textContent));
                });
              }));
              index = index + 1;
            } while (index <= pdfData.numPages);
            Promise.all(promises).then(_ => {
              resolve(data);
              reject(err => {
                console.log('some erro has occured in parsing')
              }); // reject
            })
          });
        });
      }
      // fulfilled

    }
    );
  }

  // push the data of the new page to the main array
  formatTxtArray(context) {
    let textArr: any[] = [];
    context.bidiTexts.forEach(text => {
      textArr.push(text.str);
    })
    return textArr;
  }

  readFile(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function (e: any) {
        resolve(e.target.result);
      };
      reader.onerror = reader.onabort = reject;
      reader.readAsBinaryString(file);
    });
  }

  // return uint8 array
  base64ToUint8Array(base64) {
    var raw = atob(base64); //This is a native function that decodes a base64-encoded string.
    var uint8Array = new Uint8Array(new ArrayBuffer(raw.length));
    for (var i = 0; i < raw.length; i++) {
      uint8Array[i] = raw.charCodeAt(i);
    }
    return uint8Array;
  }

}



// WEBPACK FOOTER //
// ./src/providers/document-parser/document-parser.ts